import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Container, Row, Col, Form} from "react-bootstrap";

import {useForm} from "react-hook-form";

import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {checkEmailStatus, login} from "actions/auth";
import {Link, useNavigate} from "react-router-dom";

import GoogleGIcon from "assets/icons/google-g-icon.png";
import SingleInput from "./SingleInput";
import {
  hideModal,
  setShowResetPassword,
  showRegister,
} from "actions/ui_control";

const initialState = {
  email: "",
  password: "",
  rememberMe: false,
};

function Login({}) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const {isLoggedIn} = useSelector(state => state.auth);
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Please use a valid email.")
      .required("Please provide an email."),
    password: yup.string().required("Please provide a password."),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm({
    defaultValues: initialState,
    resolver: yupResolver(schema),
  });
  const showSignUp = () => {
    dispatch(showRegister());
  };
  const showResetPassword = e => {
    e.preventDefault();
    dispatch(setShowResetPassword());
  };

  // const { message } = useSelector(state => state.message);

  const onSubmit = formValues => {
    const {email, password, rememberMe} = formValues;
    setLoading(true);

    dispatch(login(email, password, rememberMe))
      .then(res => {
        dispatch(checkEmailStatus()).then(res => {
          console.log({res});
          // To Enable Checking whether the user is verified - uncomment the 'if else' below
          // if(res.is_verified){
          navigate("/dashboard");
          dispatch(hideModal());

          //        }   else{ res}
        });
      })
      .catch(err => {
        setError(err);
        setTimeout(() => setError(null), 5000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Container>
      <Row>
        {/* Header section */}
        <Col sm={12} className="modal-header px-2">
          <h2>Welcome Back!</h2>
          <p className="mt-2 mb-0">
            Don't have an account? <Link onClick={showSignUp}>Sign up</Link>
          </p>
        </Col>

        {/* Third-party section */}
        <Col sm={12} className="modal-third-party px-2">
          <img src={GoogleGIcon} alt="google-g-icon"/>
        </Col>

        {/* Form section */}

        {/* First step */}
        <Form sm={12} noValidate onSubmit={handleSubmit(onSubmit)}>
          <SingleInput
            label="Email"
            name={"email"}
            type="email"
            errors={errors}
            register={register}
            placeholder="Email"
          />
          <SingleInput
            label="Password"
            name={"password"}
            type="password"
            errors={errors}
            register={register}
            placeholder="Password"
          />
          <div className="form-group d-flex justify-content-between">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="checkbox"
                id="rememberMe"
                {...register("rememberMe")}
              />
              <label className="form-check-label" htmlFor="rememberMe">
                Remember me
              </label>
            </div>
            <div className="text-right">
              <a href="#" onClick={showResetPassword}>
                Forgot password?
              </a>
            </div>
          </div>

          <div className="form-group pt-2 pb-2">
            <button
              type="submit"
              className="btn btn-primary btn-block btn-full"
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Login
            </button>
          </div>
          {error &&
            error.map((msg, index) => (
              <div className="form-group mt-2" key={index}>
                <div className="alert alert-danger" role="alert">
                  <React.Fragment key={index}>
                    {msg.charAt(0).toUpperCase() + msg.slice(1)}
                  </React.Fragment>
                </div>
              </div>
            ))}
        </Form>
      </Row>
    </Container>
  );
}

export default Login;
